import React from 'react';


export default function NotFoundPage() {

  return (
    <div className='not_found'>
      <h2>Erorr: you've stumbled on a lost page</h2>
    </div>
  )

}


